import React, { useEffect, useState } from "react";
import { api, apiError } from "../lib/api";
import { fmtMoney0, fmtMoney } from "../lib/format";
import { Modal, Field, Badge, Spinner, Confirm } from "../components/ui";

export default function Tresorerie() {
  const [data, setData] = useState<any>(null);
  const [filtre, setFiltre] = useState("");
  const [addMvt, setAddMvt] = useState<any>(null);
  const [addMa, setAddMa] = useState<any>(null);
  const [editSolde, setEditSolde] = useState<any>(null);
  const [del, setDel] = useState<any>(null);
  const [err, setErr] = useState<string | null>(null);

  const load = (f = filtre) =>
    api.get("/tresorerie", { params: f ? { entite: f } : {} }).then((r) => setData(r.data));
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtre]);

  if (!data) return <Spinner />;
  const k = data.kpi;

  const fmtD = (v: string) => {
    if (!v) return "";
    const p = v.split("-");
    if (p.length === 3) return `${p[2]}/${p[1]}/${p[0]}`;
    if (p.length === 2) return `${p[1]}/${p[0]}`;
    return v;
  };
  const mois = Array.from(new Set(data.mouvements.map((m: any) => m.mois))).sort() as string[];

  return (
    <div data-testid="tresorerie-page" className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-extrabold text-green">Trésorerie</h1>
        <div className="flex gap-2">
          <select data-testid="treso-filtre-entite" className="nx-input !w-auto" value={filtre} onChange={(e) => setFiltre(e.target.value)}>
            <option value="">Toutes entités</option>
            {data.entites.map((e: any) => <option key={e.id} value={e.id}>{e.code}</option>)}
          </select>
          <button data-testid="mvt-add-btn" className="nx-btn-primary" onClick={() => setAddMvt({ sens: "in", statut: "prévu", mois: new Date().toISOString().slice(0, 10) })}>
            Ajouter un mouvement
          </button>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        <div className="nx-card p-4" data-testid="treso-kpi-fonds"><p className="text-[11px] font-bold uppercase text-muted">Fonds actuels</p><p className="text-xl font-extrabold text-green">{fmtMoney0(k.fonds_actuels)}</p></div>
        <div className="nx-card p-4" data-testid="treso-kpi-entrees"><p className="text-[11px] font-bold uppercase text-muted">Total entrées</p><p className="text-xl font-extrabold text-green">{fmtMoney0(k.total_entrees)}</p></div>
        <div className="nx-card p-4" data-testid="treso-kpi-sorties"><p className="text-[11px] font-bold uppercase text-muted">Total sorties</p><p className="text-xl font-extrabold text-danger">{fmtMoney0(k.total_sorties)}</p></div>
        <div className="nx-card p-4" data-testid="treso-kpi-solde"><p className="text-[11px] font-bold uppercase text-muted">Solde prévisionnel</p><p className={`text-xl font-extrabold ${k.solde_previsionnel >= 0 ? "text-green" : "text-danger"}`}>{fmtMoney0(k.solde_previsionnel)}</p></div>
      </div>

      <div className="nx-card p-4">
        <h2 className="mb-2 text-sm font-bold text-green">Soldes de départ par entité</h2>
        <div className="flex flex-wrap gap-2">
          {data.entites.map((e: any) => (
            <button key={e.id} data-testid={`solde-btn-${e.code}`} className="rounded-lg border border-line bg-soft px-3 py-2 text-sm transition-colors hover:border-green" onClick={() => setEditSolde({ ...e })}>
              <b className="text-green">{e.code}</b> · {fmtMoney(e.solde)}
              <span className="ml-1 text-xs text-muted">(modifier)</span>
            </button>
          ))}
        </div>
      </div>

      <div className="nx-card overflow-x-auto">
        <h2 className="border-b border-line p-3 text-sm font-bold text-green">Mouvements</h2>
        <table className="nx-table">
          <thead><tr><th>Date</th><th>Entité</th><th>Sens</th><th>Libellé</th><th className="text-right">Montant</th><th>Statut</th><th className="text-right">Action</th></tr></thead>
          <tbody>
            {mois.map((m) => (
              <React.Fragment key={m}>
                {data.mouvements.filter((x: any) => x.mois === m).map((mv: any, i: number) => (
                  <tr key={mv.id} data-testid={`mvt-row-${mv.id}`}>
                    <td className="font-semibold">{i === 0 ? fmtD(m) : ""}</td>
                    <td><Badge className="bg-green text-white">{mv.entite_code}</Badge></td>
                    <td>{mv.sens === "in" ? <Badge className="bg-lime-soft text-green">Entrée</Badge> : <Badge className="bg-red-50 text-danger">Sortie</Badge>}</td>
                    <td>{mv.libelle}</td>
                    <td className={`text-right font-semibold ${mv.sens === "in" ? "text-green" : "text-danger"}`}>{mv.sens === "in" ? "+" : "−"} {fmtMoney0(mv.montant)}</td>
                    <td><Badge className={mv.statut === "réalisé" ? "bg-green text-white" : "bg-soft text-muted"}>{mv.statut}</Badge></td>
                    <td className="text-right">
                      <button data-testid={`mvt-delete-btn-${mv.id}`} className="nx-btn-danger !px-2 !py-1 text-xs" onClick={() => setDel({ kind: "mvt", id: mv.id, label: mv.libelle })}>Supprimer</button>
                    </td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      <div className="nx-card overflow-x-auto">
        <div className="flex items-center justify-between border-b border-line p-3">
          <h2 className="text-sm font-bold text-green">Marge arrière — disponible : <span data-testid="marge-arriere-dispo">{fmtMoney0(k.marge_arriere_dispo)}</span></h2>
          <button data-testid="ma-add-btn" className="nx-btn-ghost !px-2.5 !py-1 text-xs" onClick={() => setAddMa({ type: "acquise", date: new Date().toISOString().slice(0, 10) })}>Ajouter</button>
        </div>
        <table className="nx-table">
          <thead><tr><th>Date</th><th>Libellé</th><th>Type</th><th className="text-right">Montant</th><th className="text-right">Action</th></tr></thead>
          <tbody>
            {data.marge_arriere.map((ma: any) => (
              <tr key={ma.id} data-testid={`ma-row-${ma.id}`}>
                <td>{fmtD(ma.date)}</td>
                <td>{ma.libelle}</td>
                <td><Badge className={ma.type === "acquise" ? "bg-lime-soft text-green" : "bg-amber-50 text-amber"}>{ma.type}</Badge></td>
                <td className="text-right font-semibold">{fmtMoney0(ma.montant)}</td>
                <td className="text-right">
                  <button data-testid={`ma-delete-btn-${ma.id}`} className="nx-btn-danger !px-2 !py-1 text-xs" onClick={() => setDel({ kind: "ma", id: ma.id, label: ma.libelle })}>Supprimer</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {addMvt && (
        <Modal title="Nouveau mouvement" onClose={() => setAddMvt(null)} testId="mvt-modal">
          <div className="grid grid-cols-2 gap-3">
            <Field label="Date (jj/mm/aaaa)">
              <input data-testid="mvt-mois-input" type="date" className="nx-input" value={addMvt.mois} onChange={(e) => setAddMvt({ ...addMvt, mois: e.target.value })} />
            </Field>
            <Field label="Entité">
              <select data-testid="mvt-entite-select" className="nx-input" value={addMvt.entite_id || ""} onChange={(e) => setAddMvt({ ...addMvt, entite_id: e.target.value })}>
                <option value="">—</option>
                {data.entites.map((e: any) => <option key={e.id} value={e.id}>{e.code}</option>)}
              </select>
            </Field>
            <Field label="Sens">
              <select data-testid="mvt-sens-select" className="nx-input" value={addMvt.sens} onChange={(e) => setAddMvt({ ...addMvt, sens: e.target.value })}>
                <option value="in">Entrée</option>
                <option value="out">Sortie</option>
              </select>
            </Field>
            <Field label="Statut">
              <select data-testid="mvt-statut-select" className="nx-input" value={addMvt.statut} onChange={(e) => setAddMvt({ ...addMvt, statut: e.target.value })}>
                {["prévu", "à payer", "à encaisser", "réalisé"].map((s) => <option key={s}>{s}</option>)}
              </select>
            </Field>
            <Field label="Libellé" className="col-span-2">
              <input data-testid="mvt-libelle-input" className="nx-input" value={addMvt.libelle || ""} onChange={(e) => setAddMvt({ ...addMvt, libelle: e.target.value })} />
            </Field>
            <Field label="Montant">
              <input data-testid="mvt-montant-input" type="number" step="0.01" className="nx-input" value={addMvt.montant ?? ""} onChange={(e) => setAddMvt({ ...addMvt, montant: +e.target.value })} />
            </Field>
          </div>
          {err && <p className="mt-2 text-sm text-danger">{err}</p>}
          <div className="mt-4 flex justify-end gap-2">
            <button className="nx-btn-ghost" onClick={() => setAddMvt(null)}>Annuler</button>
            <button
              data-testid="mvt-save-btn"
              className="nx-btn-primary"
              disabled={!addMvt.libelle || !addMvt.montant || !addMvt.entite_id}
              onClick={async () => {
                setErr(null);
                try {
                  await api.post("/tresorerie/mouvements", addMvt);
                  setAddMvt(null);
                  load();
                } catch (e) {
                  setErr(apiError(e));
                }
              }}
            >
              Enregistrer
            </button>
          </div>
        </Modal>
      )}

      {addMa && (
        <Modal title="Marge arrière" onClose={() => setAddMa(null)} testId="ma-modal">
          <div className="grid grid-cols-2 gap-3">
            <Field label="Date (jj/mm/aaaa)">
              <input data-testid="ma-date-input" type="date" className="nx-input" value={addMa.date} onChange={(e) => setAddMa({ ...addMa, date: e.target.value })} />
            </Field>
            <Field label="Type">
              <select data-testid="ma-type-select" className="nx-input" value={addMa.type} onChange={(e) => setAddMa({ ...addMa, type: e.target.value })}>
                <option value="acquise">Acquise</option>
                <option value="utilisee">Utilisée</option>
              </select>
            </Field>
            <Field label="Libellé" className="col-span-2">
              <input data-testid="ma-libelle-input" className="nx-input" value={addMa.libelle || ""} onChange={(e) => setAddMa({ ...addMa, libelle: e.target.value })} />
            </Field>
            <Field label="Montant">
              <input data-testid="ma-montant-input" type="number" step="0.01" className="nx-input" value={addMa.montant ?? ""} onChange={(e) => setAddMa({ ...addMa, montant: +e.target.value })} />
            </Field>
          </div>
          <div className="mt-4 flex justify-end gap-2">
            <button className="nx-btn-ghost" onClick={() => setAddMa(null)}>Annuler</button>
            <button
              data-testid="ma-save-btn"
              className="nx-btn-primary"
              disabled={!addMa.libelle || !addMa.montant}
              onClick={async () => {
                await api.post("/tresorerie/marge-arriere", addMa);
                setAddMa(null);
                load();
              }}
            >
              Enregistrer
            </button>
          </div>
        </Modal>
      )}

      {editSolde && (
        <Modal title={`Solde de départ — ${editSolde.code}`} onClose={() => setEditSolde(null)} testId="solde-modal">
          <Field label="Montant">
            <input data-testid="solde-montant-input" type="number" step="0.01" className="nx-input" value={editSolde.solde ?? 0} onChange={(e) => setEditSolde({ ...editSolde, solde: +e.target.value })} />
          </Field>
          <div className="mt-4 flex justify-end gap-2">
            <button className="nx-btn-ghost" onClick={() => setEditSolde(null)}>Annuler</button>
            <button
              data-testid="solde-save-btn"
              className="nx-btn-primary"
              onClick={async () => {
                await api.put("/tresorerie/soldes", { entite_id: editSolde.id, montant: editSolde.solde });
                setEditSolde(null);
                load();
              }}
            >
              Enregistrer
            </button>
          </div>
        </Modal>
      )}

      {del && (
        <Confirm
          message={`Supprimer « ${del.label} » ?`}
          onConfirm={async () => {
            await api.delete(del.kind === "mvt" ? `/tresorerie/mouvements/${del.id}` : `/tresorerie/marge-arriere/${del.id}`);
            setDel(null);
            load();
          }}
          onCancel={() => setDel(null)}
        />
      )}
    </div>
  );
}
